import { Col, Logo, Row, Spinner2 } from 'components';
import { Api, theme } from 'lib';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { store } from '../../store';
import { Confirmation, EnterEmail, NoUserFound, ResetPassword } from './screens';

const ImageWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: ${(props) => (props.isMobile ? '100vh' : 'calc(100vw - 57%)')};
  background-color: ${theme.GREY_10};
  overflow: hidden;
  ${(props) => props.isMobile && 'display: none;'};
`;

const Image = styled.img`
  height: calc(100vh + 100px);
  position: fixed;
  right: 57%;
`;
const ForgotPassword = () => {
  // noinspection JSUnusedLocalSymbols
  const user = useSelector((state) => state.user),
    [resetStep, setResetStep] = useState('Email'),
    [email, setEmail] = useState(user?.email || ''),
    [loading, setLoading] = useState(true),
    [searchParams, setSearchParams] = useSearchParams(),
    code = searchParams.get('code'),
    lang = searchParams.get('lang') || 'en',
    navigate = useNavigate(),
    { isMobile } = useSelector((state) => state.appState),
    { i18n } = useTranslation();

  useEffect(() => {
    const onPageLoad = () => {
      i18n.changeLanguage(lang).then(() => {
        if (!code) {
          return setLoading(false);
        }
        // preliminary check to see if code is still valid
        Api.post('/users/checkPasswordResetCode', { code, lang }).then(
          /**
           * @param {string} res.err
           * @param {boolean} res.valid
           */
          (res) => {
            if (!res.valid) {
              navigate('/login');
              store.dispatch({
                type: 'HANDLE_RES',
                payload: { err: res.err }
              });
            } else {
              setLoading(false);
            }
          }
        );
      });
    };

    // Check if the page has already loaded
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad, false);
      return () => window.removeEventListener('load', onPageLoad);
    }
  }, []);

  function getComponent() {
    if (code) {
      return <ResetPassword code={code} />;
    }

    switch (resetStep) {
      case 'Email':
        return <EnterEmail email={email} setEmail={setEmail} setResetStep={setResetStep} />;
      case 'Confirmation':
        return <Confirmation />;
      case 'NoUserFound':
        return <NoUserFound email={email} setResetStep={setResetStep} />;
    }
  }

  return (
    <React.Fragment>
      {!loading && (
        <ImageWrapper isMobile={isMobile}>
          <Image src={require('assets/branding/logo-icon-grey-20.png')} />
        </ImageWrapper>
      )}
      {loading && (
        <Col wid="calc(100vw - 200px)" marg="24px 0" centerAll noFlex>
          <Spinner2 />
        </Col>
      )}
      {!loading && (
        <Col centerAll>
          <Row className="row" between pad="0 16px" ht="100vh" wid={isMobile ? '100%' : '936px'}>
            {!isMobile && <Col center wid="50%" noFlex marg="0 0 0"></Col>}

            <Col center wid={isMobile ? '100vw' : '50%'} noFlex>
              <Col center noFlex ht="100vh" wid={isMobile ? '100vw' : 'auto'}>
                <Col centerAll flexStart marg="60px 0 0" wid={isMobile ? '100vw' : '456px'}>
                  <Logo wid="296px" />

                  {getComponent()}
                </Col>
              </Col>
            </Col>
          </Row>
        </Col>
      )}
    </React.Fragment>
  );
};

export default ForgotPassword;
